import React from 'react'
import FilterInput from 'components/styled/FilterInput'
import AppliesToSelect from 'resources/rules/AppliesToSelect'

const RuleListFilter = [
    <FilterInput key="name" label="Name" source="name" />,
    <AppliesToSelect key="applies_to" source="applies_to" label="Applies To" />,
    <FilterInput key="actions" label="Actions" source="actions" />,
    <FilterInput key="attributes" label="Attributes" source="attributes" />,
    <FilterInput key="functions" label="Functions" source="functions" />,
    <FilterInput key="parameters" label="Parameters" source="parameters" />

]
export default RuleListFilter
